import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableHead,
  TableRow,
} from '~/ui/Table';
import dayjs from 'dayjs';

import styles from './UserPromotionFormTable.module.scss';
import i18n from '~/i18n';
import { Link } from 'react-router-dom';

interface IPromotionTableProps {
  data: {
    points: number;
    created_at: string;
    promo_loyalty: { name: string };
    manual_action: boolean | null;
    by_user: {
      full_name: string;
      id: number;
    };
    order_info: {
      food_order_id: number | null;
      id: number | null;
      type: string | null;
    };
  }[];
  sort: { field: string; direction: string };
  setSort: ({ field, direction }: { field: string; direction: string }) => void;
}

interface IPromotionLabelProps {
  manualAction: boolean | null;
  points: number;
  user: {
    full_name: string;
    id: number;
  };
  orderInfo: {
    food_order_id: number | null;
    id: number | null;
    type: string | null;
  };
  promo_loyalty: {
    name: string;
  };
}

const PromotionLabel = ({
  manualAction,
  points,
  user,
  orderInfo,
  promo_loyalty,
}: IPromotionLabelProps) => {
  if (manualAction === true) {
    return points < 0 ? (
      <>
        {i18n.t('manual_debit')}
        {' / '}
        <Link to={`/user/${user.id}`} className={styles.link}>
          {user.full_name}
        </Link>
      </>
    ) : (
      <>
        {i18n.t('manual_accrual')}
        {' / '}
        <Link to={`/user/${user.id}`} className={styles.link}>
          {user.full_name}
        </Link>
      </>
    );
  } else if (manualAction === false && !!orderInfo?.food_order_id) {
    return (
      <p>
        {points < 0 ? i18n.t('order_debit') : i18n.t('order_accrual')}
        <Link
          to={`/transactions/${orderInfo.food_order_id}`}
          className={styles.link}
        >
          {' '}
          #{orderInfo.food_order_id}
        </Link>
      </p>
    );
  } else if (
    manualAction === false &&
    !orderInfo?.food_order_id &&
    promo_loyalty
  ) {
    return (
      <p>
        {points < 0 ? i18n.t('promotion_debit') : i18n.t('promotion_accural')}
        <span className={styles.promoName}>{promo_loyalty.name}</span>
      </p>
    );
  } else {
    return <span> {i18n.t('manual_delete')} </span>;
  }
};

const PointQuantity = ({ point }: { point: number }) => {
  const isPositive = point > 0;

  return (
    <div className={isPositive ? styles.positive : styles.negative}>
      {isPositive
        ? `+${point} ${i18n.t('points')}`
        : `${point} ${i18n.t('points')}`}
    </div>
  );
};

export const UserPromotionFormTable = ({
  data,
  sort,
  setSort,
}: IPromotionTableProps) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead sort={sort} setSort={setSort}>
        <TableCellHead field="created_at">{t('date')}</TableCellHead>
        <TableCellHead field="points">{t('write_off_accrual')}</TableCellHead>
        <TableCellHead field="points">{t('promotion')}</TableCellHead>
      </TableHead>
      <TableBody>
        {data.map((item, idx) => (
          <TableRow key={idx}>
            <TableCell>{dayjs(item.created_at).format('DD.MM.YYYY')}</TableCell>
            <TableCell>
              <PointQuantity point={item.points} />
            </TableCell>
            <TableCell>
              <PromotionLabel
                manualAction={item.manual_action}
                points={item.points}
                user={item.by_user}
                orderInfo={item.order_info}
                promo_loyalty={item.promo_loyalty}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
